<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross')"
  ></button>
</div>

@if (text) {
  <div [innerHTML]="text" class="modal-body"></div>
}

<div class="modal-footer">
  @if (showCancelButton) {
    <button
      type="button"
      class="btn btn-outline"
      (click)="activeModal.close('Cancel')"
    >
      {{ cancelButtonLabel || 'Cancel' }}
    </button>
  }

  <button
    type="submit"
    class="btn btn-primary"
    (click)="activeModal.close('OK')"
    ngbAutofocus
  >
    {{ okButtonLabel || 'OK' }}
  </button>
</div>
